
import { Box, createStyles, Grid, IconButton, makeStyles, Table, TableContainer, TableHead, TableRow, withStyles, TableCell, Button, TableBody } from "@material-ui/core";
import { createCurrencyField, createNumberFormatField, createRadioField, createSelectField, createTextField, NumberFormat, TextField, trueFalseOptions } from "@roc/ui";
import { observer } from "mobx-react";
import { PropertyTypeFormStore } from "../../../stores/portfolioInformation/propertyTypeFormStore";
import {
  isNotBlank,
  MIXED_USE,
  MULTIFAMILY_5_PLUS,
  propertyTypes,
} from '@roc/feature-utils';
import DeleteIcon from '@material-ui/icons/Delete';
import { PortfolioInformationFormStore } from "../../../stores/portfolioInformation/portfolioInformationFormStore";
import AddIcon from '@material-ui/icons/Add';
import { formatCurrency } from "@roc/ui/utils";

const colsWidths = {
  propertyType: "50%",
  noOfProperties: "20%",
  estimatedAsIsValue: "23",
  actions: "7%",
}

const useStyles = makeStyles(theme => ({

  totalsCell: {
    textAlign: "right",
    fontWeight: "bold",
    fontSize: "20px",
  },
  totalCell: {
    fontWeight: "bold",
    fontSize: "20px",
  },
}));


interface PropertyTypesFormStoreProps {
  portfolioInformationFormStore: PortfolioInformationFormStore;
}

const StyledTableCell = withStyles(() =>
  createStyles({
    body: {
      padding: 10,
      paddingLeft: 0,
      textAlign: "left",
      border: "none"
    },
    head: {
      padding: 10,
      paddingLeft: 0,
      textAlign: "left",
    },
  })
)(TableCell);

const TotalsTableCell = withStyles(() =>
  createStyles({
    body: {
      padding: 10,
      paddingLeft: 0,
      border: "none",
      textAlign: "right",
      fontWeight: "bold",
      fontSize: "20px",
    },
  })
)(TableCell);

const TotalTableCell = withStyles(() =>
  createStyles({
    body: {
      padding: 10,
      paddingLeft: 0,
      border: "none",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "20px",
    },
  })
)(TableCell);

export const PropertyTypesForm = observer(({ portfolioInformationFormStore }: PropertyTypesFormStoreProps) => {
  const propertyTypeFormStores = portfolioInformationFormStore.propertyTypeFormStores;

  const classes = useStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell
              style={{ width: colsWidths.propertyType }}
            >
              Property Types
            </StyledTableCell>
            <StyledTableCell
              style={{ width: colsWidths.noOfProperties }}
            >
              No. of Properties
            </StyledTableCell>
            <StyledTableCell colSpan={2}
              style={{ width: colsWidths.estimatedAsIsValue }}
            >
              Estimated As-Is Value
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {propertyTypeFormStores.map(store => (<PropertyTypeForm key={store.key} propertyTypeFormStore={store} onDelete={() => portfolioInformationFormStore.deletePropertyType(store.key)} />))}
          <TableRow>
            <StyledTableCell>
              <Button
                startIcon={<AddIcon />}
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => portfolioInformationFormStore.addNewPropertyType()}
              >
                Add Property
              </Button>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <TotalsTableCell className={classes.totalsCell}>
              Totals
            </TotalsTableCell>
            <TotalTableCell className={classes.totalCell}>
              {portfolioInformationFormStore.totalNoOfProperties}
            </TotalTableCell>
            <TotalTableCell className={classes.totalCell}>
              {formatCurrency(portfolioInformationFormStore.totalEstimatedAsIsValue)}
            </TotalTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>);
});

interface PropertyTypeFormStoreProps {
  propertyTypeFormStore: PropertyTypeFormStore;
  onDelete: () => void;
}

const PropertyTypeForm = observer(({ propertyTypeFormStore, onDelete }: PropertyTypeFormStoreProps) => {

  //we remove options that are no longer in use
  const propertyTypesOptions = propertyTypes.filter(pt => ![MULTIFAMILY_5_PLUS, MIXED_USE].includes(pt.value));

  return (
    <TableRow>
      <StyledTableCell style={{ width: colsWidths.propertyType }}>
        {createSelectField({
          variant: "standard",
          store: propertyTypeFormStore,
          testId: 'propertyType',
          fieldName: 'propertyType',
          label: 'Select Property Type',
          options: propertyTypesOptions,
          standaloneLabel: false,
          displayHelperText: false
        })}
      </StyledTableCell>
      <StyledTableCell style={{ width: colsWidths.noOfProperties }}>
        {createNumberFormatField({
          label: "",
          fieldName: 'numberOfProperties',
          testId: 'numberOfProperties',
          store: propertyTypeFormStore,
          standaloneLabel: false,
          displayHelperText: false
        })}
      </StyledTableCell>
      <StyledTableCell style={{ width: colsWidths.estimatedAsIsValue }}>
        {createCurrencyField({
          label: '',
          fieldName: 'estimatedAsIsValue',
          testId: 'estimatedAsIsValue',
          store: propertyTypeFormStore,
          standaloneLabel: false,
          displayHelperText: false
        })}
      </StyledTableCell>
      <StyledTableCell style={{ width: colsWidths.actions }}>
        <IconButton onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </StyledTableCell>
    </TableRow>
  );
});